import React, { useContext } from "react"
import { faFileAlt } from "@fortawesome/pro-light-svg-icons/faFileAlt"
import IconButton from "../IconButton/IconButton"
import { TreeItem } from "@atlaskit/tree/types"
import ScalableList from "../ScalableList/ScalableList"
import { selectArticleExpanded } from "../../store/knowledgeBase/selectors"
import cn from "classnames"
import styles from "./SubArticles.module.scss"
import { SUB_ARTICLES_LIST_MAX_LENGTH, SUB_ARTICLES_LOCALES } from "./SubArticles.const"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "../../store/hooks"
import { buildKnowledgeBaseArticleUrl, buildSharedArticleActionUrl } from "../../utility/knowledgeBase/articleUrlHelper"
import { ArticleAction } from "../../models/article"
import KnowledgeBaseContext from "../KnowledgeBaseProvider/KnowledgeBaseContext"
import TooltipTrigger from "../TooltipTrigger/TooltipTrigger"
import { testId } from "../../utility/tests/testId/knowledgeBase"
import { Link } from "react-router-dom"

export type SubArticlesProps = {
    subArticles: TreeItem[]
    onSubArticleClick: (category: TreeItem) => void
}

const { tNamespace, tPath } = SUB_ARTICLES_LOCALES

const SubArticles = (props: SubArticlesProps) => {
    const { subArticles, onSubArticleClick } = props
    const { t } = useTranslation(tNamespace)
    const isArticleExpanded = useAppSelector(selectArticleExpanded)
    const { url, shareId } = useContext(KnowledgeBaseContext)

    const checkIsLongTitle = (title: string) => {
        return title.length > 40
    }

    const buildArticleUrl = (symbolCode: string) =>
        shareId
            ? buildSharedArticleActionUrl(url, symbolCode)
            : buildKnowledgeBaseArticleUrl(url, ArticleAction.View, symbolCode)

    const getContentItem = (subArticle: TreeItem) => {
        return (
            <Link
                key={subArticle.id}
                data-testid={testId.subArticleItemLink}
                className={styles.itemLink}
                to={buildArticleUrl(subArticle.data.symbolCode)}
                rel="noopener noreferrer"
                onClick={() => onSubArticleClick(subArticle)}
            >
                <TooltipTrigger
                    id={testId.subArticleItem}
                    placement="bottom"
                    content={subArticle.data.title}
                    condition={checkIsLongTitle(subArticle.data.title)}
                >
                    <IconButton
                        testId={testId.subArticleItem}
                        className={styles.subArticles__item}
                        variant="link"
                        icon={faFileAlt}
                        iconSize="lg"
                    >
                        {subArticle.data.title}
                    </IconButton>
                </TooltipTrigger>
            </Link>
        )
    }

    return (
        <div className={cn(styles.subArticles, isArticleExpanded && styles.subArticles_expanded)}>
            <h4>{t(tPath.subArticles)}</h4>
            <ScalableList
                t={t}
                items={subArticles}
                limit={SUB_ARTICLES_LIST_MAX_LENGTH}
                mainContainerClassName={styles.subArticles__body}
            >
                {getContentItem}
            </ScalableList>
        </div>
    )
}

export default SubArticles
